<app-menu [hasChanges]="loadMenu" [title]="'Reporte detallado de ventas diarias'"></app-menu>
<app-loading [show]="load"></app-loading>
<section class="section h-screen bg-white">
    <div class="pt-2 w-full md:w-2 mx-auto">
        <label>Seleccione la fecha de consulta</label>
        <div class="flex flex-1 justify-content-center">
            <p-datepicker [(ngModel)]="dateQuery" dateFormat="yy-mm-dd" showIcon="true"
                [showButtonBar]="true"></p-datepicker>
            <div class="p-2">
                <button pButton icon="pi pi-search" class="p-button p-button-success"
                    (click)="getInfoVentas()"></button>
            </div>
        </div>
    </div>
    <div class="grid col-12" *ngIf="infoVentas.length > 0">
        <div class="col-12 md:col-6">
            <label for="">Ver ventas del Vendedor</label>
            <p-select [options]="infoVendedor" [(ngModel)]="selectedSales" (onChange)="filteredDetailSales()"
                size="small">
            </p-select>
        </div>
        <div class="col-12 md:col-6">
            <label for="">Buscador</label>
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
                <input type="text" pInputText placeholder="Buscador" [(ngModel)]="txtBuscador" pSize="small"
                    (keyup)="filteredDetailSales()" />
            </div>
        </div>
    </div>

    <!--     <p-tabView [(activeIndex)]="numTab" (onChange)="filteredDetailSales()">
        <p-tabPanel header="General"> -->
    <div *ngIf="infoVentas.length > 0">
        <div class="align-items-center hidden md:grid">
            <div class="col-1">
                <h4>#</h4>
            </div>
            <div class="col-11 md:col-5 text-center">
                <h4>Información venta</h4>
            </div>
            <div class="col-12 md:col-6 text-center">
                <h4>Valores</h4>
            </div>
        </div>
        <!--Items-->
        <div class="hidden md:flex flex-wrap justify-content-center align-items-center">
            <div class="w-full md:w-3 text-center text-lg">Información Venta</div>
            <div class="w-full md:w-1 text-center text-lg">Nro. de items</div>
            <div class="w-full md:w-2 text-center text-lg">Subtotal</div>
            <div class="w-full md:w-2 text-center text-lg">Impuesto</div>
            <div class="w-full md:w-2 text-center text-lg">Descuento</div>
            <div class="w-full md:w-2 text-center text-lg">Total</div>
        </div>
        <div class="flex flex-wrap justify-content-center align-items-center"
            *ngFor="let item of infoVentasFiltered; let index=index">
            <div class="w-full md:w-3 text-center">
                <p><b>Nro. de venta:</b>&nbsp;{{item.idVenta}} <span class="p-2 cursor-pointer"><i class="pi pi-eye"
                            (click)="openRecibo(item.idVenta, (item.integration?.idIntegracion??'') !=''?3:infoParametrizacion.idComprobante)"></i></span><br>
                    <b>Cliente:</b>&nbsp; {{ (item.cliente?.razonSocial ??"NA")!="NA" ?
                    item.cliente?.razonSocial :
                    item.cliente?.nombres + ' ' + (item.cliente?.apellidos ?? '')|
                    uppercase}}
                </p>
                <button *ngIf="(item.integration?.idIntegracion??'') !=''" pButton icon="pi pi-eye pl-2"
                    (click)="openFE(item.idVenta)" label="VER FE" class="p-button p-button-outlined w-auto">
                </button>

                <div class="pl-2 pr-2"
                    *ngIf="(item.integration?.idIntegracion??'') =='' && (item.integration?.message??'') !=''">
                    Se ha
                    presentado error al envio de la
                    FE <br>
                    <div class="flex gap-2 justify-content-center"><button pButton icon="pi pi-refresh"
                            label="Reintentar" class="p-button p-button-primary w-auto"
                            (click)="setFacturaElectronicaSIIGO(item)">
                        </button>
                        <button pButton icon="pi i-eye" label="Ver error" class="p-button p-button-warn"
                            (click)="item.viewError=!item.viewError"></button>
                    </div>

                    <div *ngIf="item.viewError">{{item.integration?.message}}</div>
                </div>
            </div>
            <div class="w-full md:w-1 md:text-center">
                <b class="inline  md:hidden">Nro. de items: </b>{{item.detalle.length}}
            </div>
            <div class="w-full md:w-2 md:text-center">
                <b class="inline  md:hidden">Subtotal: </b>{{item.subtotal | currency}}
            </div>
            <div class="w-full md:w-2 md:text-center">
                <b class="inline md:hidden">Impuesto: </b>{{item.impuesto | currency}}
            </div>
            <div class="w-full md:w-2 md:text-center">
                <b class="inline  md:hidden">Descuento: </b>{{item.descuento | currency}}
            </div>
            <div class="w-full md:w-2 md:text-center">
                <b class="inline  md:hidden">Total:</b> {{(item.subtotal + item.impuesto) | currency}}
            </div>
            <div class="w-full">
                <hr>
            </div>
        </div>
    </div>
    <!-- </p-tabPanel>
        <p-tabPanel header="Detallado">
            <div class="m-3" *ngIf="infoDetalle.length > 0">
                <div class="grid align-items-center">
                    <div class="col-1">
                        <h4>#</h4>
                    </div>
                    <div class="col-5 md:col-3">
                        <h4>Información venta</h4>
                    </div>
                    <div class="col-6 md:col-4">
                        <h4>Información producto</h4>
                    </div>
                    <div class="col-12 md:col-4">
                        <h4>Valores</h4>
                    </div>
                </div>

                <div class="grid align-items-center" *ngFor="let row of infoDetalleFiltered; let $index=index">
                    <div class="col-1">
                        <p>{{$index+1}}</p>
                    </div>
                    <div class="col-5 md:col-3">
                        <p><b>Nro. venta:</b> {{row.venta}}</p>
                        <p><b>Cliente: {{row.cliente?.toUpperCase()}}</b> </p>
                        <p><b>Vendedor:</b> {{row.vendedor.toUpperCase()}}</p>
                        <p><b>Estado:</b> {{row.estado}}</p>
                        <p class="text-center" *ngIf="row.idEstado==3 || row.idEstado==4">
                            <button pButton icon="pi pi-tag" (click)="openRecibo(row.venta )" label="VER RECIBO"
                                class="p-button p-button-outlined w-auto">
                            </button>
                        </p>
                    </div>
                    <div class="col-6 md:col-4">
                        <p><b>Descripción:</b> {{row.descripcionCorta}}</p>
                        <p><b>Código de barras:</b> {{row.codBarras}}</p>
                        <p><b>Referencia:</b> {{row.referencia}}</p>
                    </div>
                    <div class="col-12 md:col-4">
                        <p><b>Cantidad:</b> {{row.cantidad}}</p>
                        <p><b>Subtotal:</b> {{row.subtotal | currency}}</p>
                        <p><b>Impuesto:</b> {{row.impuesto | currency}}</p>
                        <p><b>Descuento:</b> {{row.descuento | currency}}</p>
                        <p><b>Total:</b> {{row.total | currency}}</p>
                    </div>
                    <div class="col-12">
                        <hr>
                    </div>

                </div>
            </div>

        </p-tabPanel> -->




</section>

<div class="fixed bottom-0 mt-4 flex right-50">
    <div class="w-full" *ngIf="infoVentas.length > 0">
        <button pButton class="p-button p-button-success" icon="pi pi-eye" label="RESUMEN"
            (click)="viewResumen= true"></button>
    </div>

</div>

<p-dialog header="Información Venta" [modal]="true" [(visible)]="displayDetail" [style]="{width: '90vw'}"
    [baseZIndex]="10000">
    <div class="mt-3 grid hidden md:flex" *ngIf="detalleVenta.length > 0">
        <div class="col-5 text-center">PRODUCTO</div>
        <div class="col-2 text-center">CANTIDAD</div>
        <div class="col-5 text-center">TOTAL</div>
    </div>
    <div class="mt-3 grid" *ngFor="let row of detalleVenta; let $index =index">
        <div class="col-12 md:col-1 text-center">Item {{$index +1}}</div>
        <div class="col-12 md:col-4 text-center"><b>{{row.idProductoNavigation.descripcionCorta}}</b> <br>
            <b>Marca : {{row.idProductoNavigation.marca}} </b>
        </div>
        <div class="col-12 md:col-2 text-center"><span class="p-d-md-none">Cantidad: </span>{{row.cantidad}}</div>
        <div class="col-12 md:col-5 text-center">Subtotal : {{row.subtotal | currency}} <br>
            Impuesto: {{row.impuesto | currency}}<br>
            Descuento: {{row.descuento | currency}}<br>
            <b>TOTAL: {{(row.subtotal + row.impuesto) | currency}}</b>
        </div>
        <div class="col-12">
            <hr>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="displayDetail=false" label="Ok" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="Resumen de venta" [modal]="true" [(visible)]="viewResumen" [style]="{width: '90vw'}"
    [baseZIndex]="10000">
    <div class="mx-auto w-full flex flex-wrap bg-white justify-content-center pt-3 pb-2" *ngIf="viewResumen">
        <div class="text-center w-full md:w-6">
            <h4 class="text-uppercase m-0">Ventas</h4>
            # de items : {{nroVentas}} |
            Subtotal : {{subtotal | currency}} |
            Impuesto: {{impuesto | currency}}|
            <b>TOTAL: {{(subtotal + impuesto) | currency}} </b>
        </div>
        <div class="text-center w-full md:w-6" *ngIf="subtotalNC > 0 ">
            <h4 class="text-uppercase m-0">Notas credito</h4>
            # de nc : {{nroNC}} |
            Subtotal : {{subtotalNC | currency}} |
            Impuesto: {{impuestoNC | currency}}|
            <b>TOTAL: {{(subtotalNC + impuestoNC) | currency}} </b>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="viewResumen=false" label="Ok" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>

<p-toast>
</p-toast>